import _ from 'lodash';

export const mixinWatchDebug = {
  // evaluateForErrors is a universal watcher for computed errors in the app.
  // It is only to be used in development mode. But watching this computed
  // value, it forces the component to cascade over all computed values and
  // force their evaluation. If any of them evaluate to errors, they are
  // printed to the console.
  evaluateForErrors: {
    handler: function handle(errs) {
      if (errs && errs.length > 0) {
        _.forEach(errs, (err) => {
          // Exclude Element UI errors.
          if (!_.includes(_.get(this, '$vnode.tag'), '-El') &&
            !_.includes(_.get(this, '$vnode.tag'), 'e-chart')) {
            console.error('Computed errors detected on computed property ' +
              `'${err[0]}' in '${_.get(this, '$vnode.tag')}'!`);
            console.error(err[1]);
          }
        });
      }
    },
    immediate: true,
    deep: true,
  },
};
